import { useZoomContext } from '@splunk/visualization-context/ZoomContext';

/**
 * Hook that provides the current scale factor based on zoom context and fullscreen state.
 * Returns 1 if a non-BODY fullscreen element is active, otherwise returns the current zoom level.
 *
 * @returns {number} The current scale factor
 */
export const useScaleFactor = (): number => {
    const zoom = useZoomContext();

    // Force scale factor to 1 if a non-BODY fullscreen element is active
    const fullscreenEl = typeof document !== 'undefined' ? document.fullscreenElement : null;
    if (fullscreenEl && fullscreenEl.tagName !== 'BODY') {
        return 1;
    }

    return zoom || 1;
};
